import { Chart } from 'react-google-charts';
import React, { Component } from 'react';
import './GraphDailyOrderComponent.scss';
import { Card } from 'react-bootstrap';
import Axios from 'axios';

class GraphDailyOrderComponent extends Component {
	state = {
		type : 'quantity',
		data : [],
	};

	constructor(props) {
		super(props);
	}

	async componentDidMount() {
		if(this.props.type === 'quantity'){
			let data = await this.getQuantityData(this.props.initialDate, this.props.finalDate);
			this.setState({
				type:this.props.type,
				data:data
			});
		}
		else if(this.props.type === 'amount'){
			let data = await this.getAmountData(this.props.initialDate, this.props.finalDate);
			this.setState({
				type:this.props.type,
				data:data
			});
		}
	}

	componentDidUpdate(prev) {
		
		
	}

	async getQuantityData(initialDate, finalDate){
		const params = {
			initial_date:initialDate,
			final_date:finalDate
		};
		return Axios.get(process.env.REACT_APP_API_STATISTICS_URL + '/v1/center/order-quantity', { params: params }, {
			responseType: 'json',
		})
		.then((response) => {
			return response.data.data;
		});
	}

	async getAmountData(initialDate, finalDate){
		const params = {
			initial_date:initialDate,
			final_date:finalDate
		};
		return Axios.get(process.env.REACT_APP_API_STATISTICS_URL + '/v1/center/order-amount', { params: params }, {
			responseType: 'json',
		})
		.then((response) => {
			return response.data.data;
		});
	}

	render() {
		let title = 'Pedidos del día (Cantidad)';
		if(this.props.type === 'amount'){
			title = 'Pedidos del día (Monto)'
		}


		const options = { 
			legend: { position: 'top' },
			bars: 'horizontal',
		};

		return (
			
			<div>
				<Card.Header>{title}</Card.Header>
				<Card className='mb-2' border='primary'>
					<Card.Body>
					{ this.state.data.length > 1 &&
					<Chart 
						chartType='Bar'
						width='100%'
						height='2000px'
						data={this.state.data}
						options={options}
					/>
					}
					</Card.Body>
				</Card>
			</div>);
	}
}

export default GraphDailyOrderComponent;